// extracted by mini-css-extract-plugin
export default {"cart-form":"CartForm_cart-form__VF90+","action":"CartForm_action__J2wy7"};